import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'
import Builder from './Builder.js'

ReactDOM.render(
  <Builder label='zeroTile'/>,
  document.getElementById('root')
);
